import React from 'react'
import ic_error from '../assets/ic_error.png';
import { Typography } from '@material-ui/core';

export default function ErrorRequest(props) {
    const errorMessage = props.message
    return (
        <div className="App app-popup-show">
            <div className="popup-content background-white" style={{ borderRadius: 8, backgroundColor: 'white', height: '30vh', display: 'grid' }}>
                <div style={{margin: 'auto'}}>
                    <div style={{width: 90, height: 90, borderRadius: 70, backgroundColor: '#34b68b', border: '3px solid #b3fde4', placeContent: 'center'}}>
                        {/* <img src={circle} style={{width: 100, height: 100}}/> */}
                        <img src={ic_error} style={{width: 60, height: 60, marginTop: 10}}/>
                    </div>
                    <Typography style={{fontStyle: 'bold', letterSpacing: 1.5, fontFamily: 'poppins', fontSize: 18}}>Error</Typography>
                </div>
                <div style={{ padding: '0 20px'}}>
                    <Typography>{errorMessage}</Typography>
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: 'auto' }}>
                    <div onClick={() => props.close(false)} style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                        <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Tutup</Typography>
                    </div>
                </div>
            </div>
        </div>
    )
}